@if (this.vehicleId > 0) {
  @if (this.error) { <div class="alert alert-danger">{{ this.error }}</div> }

  <h3 class='header'>Inspections</h3>
  <br />
  <table class='table table-sm table-hover'>
    <thead>
      <tr><th>Inspection</th><th>Interval</th><th>Next due</th><th>Last done</th><th></th></tr>
    </thead>
    <tbody>
      @for (i of this.inspections; track i.id) {
        <tr>
          <td><span class='badge' [style.background]='i.inspectionType?.colour' style='color:white'>&nbsp;</span> {{ i.inspectionType?.name }}</td>
          <td>{{ i.inspectionType ? this.describeInterval(i.inspectionType) : '' }}</td>
          <td [class.text-danger]='i.nextDueDate < this.today'>
            {{ this.ukDate(i.nextDueDate) }} @if (i.nextDueDate < this.today) { <span class='badge badge-danger'>Overdue</span> }
          </td>
          <td>{{ this.ukDate(i.lastDoneDate) }}</td>
          <td style='text-align:right; white-space:nowrap'>
            <button type='button' class='btn btn-secondary btn-sm' (click)='this.open(i, "complete")'><i class='fas fa-check'></i> Mark done</button>&nbsp;
            <button type='button' class='btn btn-secondary btn-sm' (click)='this.open(i, "due")'><i class='fas fa-calendar-day'></i> Change due</button>&nbsp;
            <button type='button' class='btn btn-danger btn-sm' (click)='this.remove(i)'><i class='fas fa-trash'></i></button>
          </td>
        </tr>
      } @empty {
        <tr><td colspan='5' class='text-muted'>No inspections set up for this vehicle yet.</td></tr>
      }
    </tbody>
  </table>

  <div class="form-row">
    <div class="form-group col-md-4">
      <label>Add inspection</label>
      <select class="form-control" [(ngModel)]='this.newTypeId'>
        <option [ngValue]='-1'>Choose an inspection type</option>
        @for (t of this.availableTypes(); track t.id) { <option [ngValue]='t.id'>{{ t.name }} ({{ this.describeInterval(t) }})</option> }
      </select>
    </div>
    <div class="form-group col-md-3">
      <label>Next due date</label>
      <input type="date" class="form-control" [(ngModel)]='this.newDue'>
    </div>
    <div class="form-group col-md-2">
      <label>&nbsp;</label>
      <button type='button' class="btn btn-secondary form-control" (click)='this.add()'><i class='fas fa-plus'></i> Add</button>
    </div>
  </div>

  <br />
  <h3 class='header'>History</h3>
  <br />
  <table class='table table-sm'>
    <thead>
      <tr><th>Inspection</th><th>Was due</th><th>Done</th><th>Next due set to</th><th>Notes</th></tr>
    </thead>
    <tbody>
      @for (r of this.history; track r.id) {
        <tr>
          <td>{{ r.inspectionType?.name }}</td>
          <td>{{ this.ukDate(r.dueDate) }}</td>
          <td>{{ this.ukDate(r.doneDate) }}</td>
          <td>{{ this.ukDate(r.nextDueDate) }}</td>
          <td>{{ r.notes }}</td>
        </tr>
      } @empty {
        <tr><td colspan='5' class='text-muted'>Nothing marked done yet.</td></tr>
      }
    </tbody>
  </table>

  <app-inspection-action-modal modalId='vehicleInspectionAction' [target]='this.target' [mode]='this.mode' (saved)='this.load()'></app-inspection-action-modal>
} @else {
  <p class='text-muted'>Save the vehicle first, then add its inspections here.</p>
}
